import { render, staticRenderFns } from "./SendReminderEmailModal.vue?vue&type=template&id=5399ea9c&scoped=true&"
import script from "./SendReminderEmailModal.vue?vue&type=script&lang=js&"
export * from "./SendReminderEmailModal.vue?vue&type=script&lang=js&"
import style0 from "./SendReminderEmailModal.vue?vue&type=style&index=0&id=5399ea9c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5399ea9c",
  null
  
)

component.options.__file = "SendReminderEmailModal.vue"
export default component.exports